import React from "react";
import { Box } from "@mui/material";
import { handleLandingMediaError, isSvgLandingMedia } from "../utils/landingMedia";

function supportsLogoMask() {
  return typeof CSS !== "undefined" && (
    CSS.supports?.("mask-image", 'url("")') ||
    CSS.supports?.("-webkit-mask-image", 'url("")')
  );
}

function cssMaskUrl(value) {
  const safe = String(value || "")
    .replace(/\\/g, "\\\\")
    .replace(/"/g, '\\"')
    .replace(/[\n\r\f]/g, "");
  return `url("${safe}")`;
}

export default function BrandLogoImage({
  src,
  alt = "",
  logoColor = "",
  sx = {},
  onError = handleLandingMediaError,
}) {
  const color = String(logoColor || "").trim();
  const [recolorUnavailable, setRecolorUnavailable] = React.useState(false);

  React.useEffect(() => {
    setRecolorUnavailable(false);
  }, [src]);

  const handleError = (event) => {
    setRecolorUnavailable(true);
    onError?.(event);
  };
  const recolor = Boolean(
    !recolorUnavailable && color && isSvgLandingMedia(src) && supportsLogoMask()
  );

  if (!recolor) {
    return <Box component="img" src={src} alt={alt} onError={handleError} sx={sx} />;
  }

  return (
    <Box sx={{ display: "inline-grid", maxWidth: "100%", verticalAlign: "middle" }}>
      <Box
        component="img"
        src={src}
        alt={alt}
        onError={handleError}
        sx={{ ...sx, gridArea: "1 / 1", visibility: "hidden" }}
      />
      <Box
        aria-hidden="true"
        sx={{
          gridArea: "1 / 1",
          alignSelf: "stretch",
          justifySelf: "stretch",
          width: "100%",
          height: "100%",
          bgcolor: color,
          WebkitMaskImage: cssMaskUrl(src),
          maskImage: cssMaskUrl(src),
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskSize: "contain",
          maskSize: "contain",
          WebkitMaskPosition: sx?.objectPosition || "center",
          maskPosition: sx?.objectPosition || "center",
          pointerEvents: "none",
        }}
      />
    </Box>
  );
}
